import React from 'react';
import { Link } from 'react-router-dom';
import {Icon, ListItem, ListItemText} from '@material-ui/core';
import {Badge} from '../../../index';
import clsx from 'clsx';
import IntlMessages from '../../../utility/IntlMessages';
import useStyles from './HorizontalItem.style';
import Box from '@material-ui/core/Box';
import {NavItemProps} from '../../../../modules/routesConfig';
import {RouteComponentProps, withRouter} from 'react-router-dom';

interface HorizontalItemProps extends RouteComponentProps<any> {
  item: NavItemProps;
  dense?: string;
  nestedLevel?: number;
  qaPendingTotal?: any
}

const HorizontalItem: React.FC<HorizontalItemProps> = ({
  item,
  location,
  history,
  dense,
  qaPendingTotal
}) => {
  const classes = useStyles();
  const {pathname} = location;
  const active = isUrlInChildren(item, pathname);
  const allowBadges = ['qa'];

  function isUrlInChildren(parent: any, url: string) {
    if (!parent.children) {
      return false;
    }

    for (let i = 0; i < parent.children.length; i++) {
      if (parent.children[i].children) {
        if (isUrlInChildren(parent.children[i], url)) {
          return true;
        }
      }

      if (
        parent.children[i].url === url ||
        url.includes(parent.children[i].url)
      ) {
        return true;
      }
    }

    return false;
  }

  return (
    <ListItem
      // component={Link}
      // to={item.url ? item.url : '/'}
      // onClick={() => history.push(item.url ? item.url : '/')}
      // className={clsx('navItemSubmenu', classes.root, dense && 'dense', { active: pathname === item.url, })}
        style={{justifyContent: 'center'}}
      >
      {item.icon && (
        <Box fontSize={{xs: 16, xl: 18}} mr={3} clone>
          <Icon style={{color: active ? 'white' : 'action'}}>{item.icon}</Icon>
        </Box>
      )}
      <ListItemText
        className='navLinkTextSubmenu'
        style={{flex: '0 1 auto'}}
        primary={
          <Link 
            to={item.url ? item.url : '/'} 
            className={clsx('navItemSubmenu', classes.root, dense && 'dense', {
              // active: pathname === item.url,
              active: item.url && pathname.includes(item.url),
            })}
          >
            <IntlMessages id={item.messageId} />
          </Link>
      }
      />
      {/* item.count &&  */}
      {allowBadges.includes(item.id) && Number(qaPendingTotal) > 0 && (
        <Box ml={1} mt={-4}>
          <Badge count={qaPendingTotal} color={item.color} />
        </Box>
      )}
    </ListItem>
  );
};

export default withRouter(HorizontalItem);
